import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import isEmpty from 'lodash/isEmpty';
import React, { useState } from 'react';
import { Button } from '../../subkit-ui';
import { AcceptTerms } from '../AcceptTerms';
import { TWInput } from '../TWInput';
import PromoCode from './PromoCode';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ExistingCardForm = function ExistingCardForm(_ref) {
  var title = _ref.title,
      buttonText = _ref.buttonText,
      paymentDetails = _ref.paymentDetails,
      providerService = _ref.providerService,
      serverError = _ref.serverError,
      userNameExists = _ref.userNameExists,
      userAgreedToSubkitTerms = _ref.userAgreedToSubkitTerms,
      userId = _ref.userId,
      onConfirmPayment = _ref.onConfirmPayment,
      updateUser = _ref.updateUser,
      icon = _ref.icon,
      order = _ref.order,
      getOrder = _ref.getOrder,
      updateOrder = _ref.updateOrder,
      isSubscription = _ref.isSubscription,
      setForgetPaymentDetails = _ref.setForgetPaymentDetails;

  var _useState = useState({
    firstName: '',
    lastName: ''
  }),
      userInfo = _useState[0],
      setUserInfo = _useState[1];

  var _useState2 = useState(false),
      isValid = _useState2[0],
      setIsValid = _useState2[1]; // eslint-disable-next-line


  var _useState3 = useState(null),
      error = _useState3[0],
      setError = _useState3[1];

  var _useState4 = useState(false),
      receiveServiceEmails = _useState4[0],
      setReceiveServiceEmails = _useState4[1];

  var _useState5 = useState(false),
      acceptServiceTerms = _useState5[0],
      setAcceptServiceTerms = _useState5[1];

  var handleAcceptServiceTerms = function handleAcceptServiceTerms() {
    setAcceptServiceTerms(!acceptServiceTerms);
    updateValidity({
      acceptServiceTerms: !acceptServiceTerms
    });
  };

  var handleReceiveServiceEmails = function handleReceiveServiceEmails() {
    setReceiveServiceEmails(!receiveServiceEmails);
  };

  var renderedError = error || serverError;

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(evt) {
      var payload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              evt.preventDefault();
              payload = {};

              if (userInfo.firstName) {
                payload.firstName = userInfo.firstName;
              }

              if (userInfo.lastName) {
                payload.lastName = userInfo.lastName;
              }

              payload.agreedToTerms = acceptServiceTerms;

              if (isEmpty(payload)) {
                _context.next = 8;
                break;
              }

              _context.next = 8;
              return updateUser(userId, payload);

            case 8:
              return _context.abrupt("return", onConfirmPayment(receiveServiceEmails));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleUserInfoChange = function handleUserInfoChange(event) {
    var nextUserInfo = _objectSpread(_objectSpread({}, userInfo), {}, _defineProperty({}, event.target.name, event.target.value));

    setUserInfo(nextUserInfo);
    updateValidity(nextUserInfo);
  };

  var updateValidity = function updateValidity(validationInfo) {
    var validity = _objectSpread(_objectSpread({
      acceptServiceTerms: acceptServiceTerms
    }, userInfo), validationInfo);

    var nextIsValid = validity.acceptServiceTerms;

    if (!userNameExists) {
      nextIsValid = !!validity.firstName && !!validity.lastName && nextIsValid;
    }

    setIsValid(nextIsValid);
  };

  return /*#__PURE__*/_jsxs("form", {
    name: "paymentMethod",
    children: [title && /*#__PURE__*/_jsx("h2", {
      children: title
    }), !userNameExists && /*#__PURE__*/_jsxs("div", {
      className: "flex w-full mb-4",
      children: [/*#__PURE__*/_jsx("div", {
        className: "w-1/2 pr-2.5",
        children: /*#__PURE__*/_jsx(TWInput, {
          format: "rounded",
          label: "First Name",
          placeholder: "Jacob",
          name: "firstName",
          value: userInfo.firstName,
          onChange: handleUserInfoChange,
          onBlur: updateValidity
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "w-1/2 pl-2.5",
        children: /*#__PURE__*/_jsx(TWInput, {
          format: "rounded",
          label: "Last Name",
          placeholder: "Andrews",
          name: "lastName",
          value: userInfo.lastName,
          onChange: handleUserInfoChange,
          onBlur: updateValidity
        })
      })]
    }), /*#__PURE__*/_jsxs("p", {
      className: "flex",
      children: [/*#__PURE__*/_jsxs("span", {
        className: "block text-base mr-2",
        children: [paymentDetails.type.toUpperCase(), " ending in ", paymentDetails.last4, "."]
      }), /*#__PURE__*/_jsx("span", {
        className: "block text-subkit-primary text-base cursor-pointer",
        onClick: function onClick() {
          setForgetPaymentDetails(true);
        },
        children: "Use a different card"
      })]
    }), renderedError && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("p", {
        className: "text-red-900 fw-500",
        children: renderedError.toString()
      })
    }), (order === null || order === void 0 ? void 0 : order.planId) && !!getOrder && !!updateOrder && /*#__PURE__*/_jsx("div", {
      className: "mt-2 mb-6",
      children: /*#__PURE__*/_jsx(PromoCode, {
        order: order,
        getOrder: getOrder,
        updateOrder: updateOrder
      })
    }), /*#__PURE__*/_jsx(AcceptTerms, {
      handleAcceptServiceTerms: handleAcceptServiceTerms,
      handleReceiveServiceEmails: handleReceiveServiceEmails,
      receiveServiceEmails: receiveServiceEmails,
      acceptServiceTerms: acceptServiceTerms,
      providerService: providerService,
      userAgreedToSubkitTerms: userAgreedToSubkitTerms,
      isSubscription: isSubscription
    }), /*#__PURE__*/_jsx(Button, {
      onClick: onSubmit,
      disabled: isSubscription ? !isValid || !receiveServiceEmails : !isValid,
      text: buttonText,
      icon: icon,
      iconType: "solid",
      loadingText: "Loading"
    })]
  });
};
ExistingCardForm.defaultProps = {
  title: '',
  buttonText: 'Confirm and Pay',
  showFooter: true
};